<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.5,12.07C14.5,12.07,14.5,9.93,14.5,9.93C15.36,9.71,16,8.93,16,8C16,6.9,15.1,6,14,6C13.07,6,12.29,6.64,12.07,7.5C12.07,7.5,9.93,7.5,9.93,7.5C9.75,6.8,9.2,6.25,8.5,6.07C8.5,6.07,8.5,3.93,8.5,3.93C9.36,3.71,10,2.93,10,2C10,0.9,9.1,0,8,0C6.9,0,6,0.9,6,2C6,2.93,6.64,3.71,7.5,3.93C7.5,3.93,7.5,6.07,7.5,6.07C6.8,6.25,6.25,6.8,6.07,7.5C6.07,7.5,3.93,7.5,3.93,7.5C3.71,6.64,2.93,6,2,6C0.9,6,0,6.9,0,8C0,8.93,0.64,9.71,1.5,9.93C1.5,9.93,1.5,12.07,1.5,12.07C0.64,12.29,0,13.07,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,13.07,3.36,12.29,2.5,12.07C2.5,12.07,2.5,9.93,2.5,9.93C3.2,9.75,3.75,9.2,3.93,8.5C3.93,8.5,6.07,8.5,6.07,8.5C6.25,9.2,6.8,9.75,7.5,9.93C7.5,9.93,7.5,12.07,7.5,12.07C6.64,12.29,6,13.07,6,14C6,15.1,6.9,16,8,16C9.1,16,10,15.1,10,14C10,13.07,9.36,12.29,8.5,12.07C8.5,12.07,8.5,9.93,8.5,9.93C9.2,9.75,9.75,9.2,9.93,8.5C9.93,8.5,12.07,8.5,12.07,8.5C12.25,9.2,12.8,9.75,13.5,9.93C13.5,9.93,13.5,12.07,13.5,12.07C12.64,12.29,12,13.07,12,14C12,15.1,12.9,16,14,16C15.1,16,16,15.1,16,14C16,13.07,15.36,12.29,14.5,12.07C14.5,12.07,14.5,12.07,14.5,12.07Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutHierarchy',
} as DefineComponent
</script>
